import React from 'react';
import { Typography, Box } from '@material-ui/core';

function WarehouseCaption({ label, description }) {
  return (
    <Box>
      <Typography variant="caption" display="block">
        {label}
      </Typography>
      <Typography variant="h3" color="primary">
        {description}
      </Typography>
    </Box>
  );
}

export default WarehouseCaption;
